import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { BlockGuard } from '../../types/api/Block';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';

import {
  MembershipsByPageType,
  UserMembershipAccordion,
  UserMembershipDefault,
  UserMembershipEdit,
} from '../../_lib/components/UserMemberships';

export type TopicMembershipsEditProps = MembershipsByPageType<{
  teamroom?: UserMembershipEdit[];
  topic?: UserMembershipEdit[];
  task?: UserMembershipEdit[];
}>;

export type TopicMembershipsDefaultProps = MembershipsByPageType<{
  teamroom?: UserMembershipDefault[];
  topic?: UserMembershipDefault[];
  task?: UserMembershipDefault[];
}>;

export type TopicMembershipsBlockProps = Views<
  DefaultView<TopicMembershipsDefaultProps> & OptionalEditView<TopicMembershipsEditProps>
>;

/**
 * TopicMembershipsBlock displaying information about a single Users Roles in different Pages ( teamrooms e.g)
 */
function TopicMemberships({ views }: TopicMembershipsBlockProps) {
  const { editModeInfo } = useAppContext();

  const { memberships } = editModeInfo.active && views.edit ? views.edit.embedded : views.default.embedded;

  return <UserMembershipAccordion memberships={memberships} order={['task', 'topic', 'teamroom']} />;
}

export const TopicMembershipsBlock = asFetchableBlock(TopicMemberships, BlockType.topicMemberships);
export type TopicMembershipsBlock = ComponentProps<typeof TopicMembershipsBlock>;
export const isTopicMembershipsBlock = BlockGuard<TopicMembershipsBlock>(BlockType.topicMemberships);
